import { EmployeeRolesEnum } from "./enum/employee-enum";

export class UnitRequest{
    unitId:number;
    role?:EmployeeRolesEnum|string;
    state?:string
    itemCategoryId?:number
    plantLotNumber?:string
    companyId?:number
    destinationId?:number
fromDate?:any
toDate?:any
financialYear?:string
containerStatus?:string
stockInType?:string
lotType?:string
    constructor(unitId:number, role?:EmployeeRolesEnum|string,state?:string,itemCategoryId?:number,plantLotNumber?:string,companyId?:number,destinationId?:number,fromDate?:any,toDate?:any,financialYear?:string,containerStatus?:string,stockInType?:string,lotType?:string

    ){
        this.unitId = unitId;
        this.role = role;
        this.state = state;
        this.itemCategoryId = itemCategoryId
        this.plantLotNumber=plantLotNumber
        this.companyId=companyId
        this.destinationId=destinationId
        this.fromDate=fromDate
        this.toDate=toDate
        this.financialYear=financialYear
        this.containerStatus=containerStatus
        this.stockInType = stockInType
        this.lotType = lotType
    }
}


export class SaleOrderIdRequest {
    saleOrderId: number;

    /**
     * @param saleOrderId
    */
    constructor(saleOrderId?: number){
       this.saleOrderId=saleOrderId;
    }
}